import React from 'react'

const Arrow = () => {
  return (
    <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
        d="M7.29289 0.292892C7.68342 -0.0976314 8.31658 -0.0976315 8.70711 0.292892L15.0711 6.65685C15.4616 7.04738 15.4616 7.68054 15.0711 
        8.07107C14.6805 8.46159 14.0474 8.46159 13.6569 8.07107L8 2.41421L2.34315 8.07107C1.95262 8.46159 1.31946 8.46159 0.928932 8.07107C0.538407 
        7.68054 0.538407 7.04738 0.928932 6.65685L7.29289 0.292892ZM7 21L7 1L9 1L9 21L7 21Z" 
        fill="#D2BEB5"
        />
    </svg>
  )
}

export default Arrow